<div class="dalog-header">
  <h2>
    {{
      data?.type
        ? toTitleCase(data?.type) +
          (data?.existing?.length
            ? "(" + data?.existing?.length + ")"
            : attachments.value?.length
            ? "(" + attachments.value?.length + ")"
            : "") +
          (data?.expense?.expenseDate
            ? " of date " + (data?.expense?.expenseDate | date)
            : "")
        : "Attachments"
    }}
  </h2>
  <button
    [disabled]="
      data?.type == 'fareAttachments' &&
      !(formGroup.value.attachments?.length || data?.existing?.length)
    "
    type="button"
    class="btn-cust-close"
    (click)="closeModal()"
  >
    <i class="icon-close"></i>
  </button>
</div>
<mat-dialog-content>
  @if (data?.existing?.length) {
  <div class="row">
    @for (item of data?.existing; track $index) {
    <ng-container *ngIf="item?.receiptPath">
      <!-- <div class="col-md-12">
        <div class="row align-items-center">
          <a
            class="col-md-11"
            [href]="Global.BACKEND_URL + '/Attachments/' + item?.receiptPath"
            target="_blank"
          >
            {{ item?.receiptName }}
          </a>
          <div class="col-md-1">
            <button mat-icon-button (click)="deleteAttachment(item, $index)">
              <i class="fa fa-trash text-danger" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div> -->
      <div class="col-md-12 pb-2">
        <div
          class="d-flex align-items-center position-relative justify-content-between"
        >
          <a
            class="pointer"
            (click)="
              downloadFile(
                Global.BACKEND_URL + folderPath + item?.receiptPath,
                item?.receiptName
              )
            "
          >
            @if (Global.isImage(item?.receiptName)) {
            <img
              [src]="Global.BACKEND_URL + folderPath + item?.receiptPath"
              alt=""
              class="img-fluid"
            />
            } @else {
            {{ item?.receiptName }}
            }
          </a>
          <div
            [class]="
              Global.isImage(item?.receiptName) ? 'image-action' : 'p-0 m-0'
            "
          >
            <button
              *ngIf="!data?.view_only"
              mat-icon-button
              (click)="deleteAttachment(item, $index)"
              [matTooltip]="'Remove File'"
            >
              <i class="fa fa-trash text-danger" aria-hidden="true"></i>
            </button>
            @if($last){
            <button
              *ngIf="!data?.view_only"
              mat-icon-button
              (click)="addMore()"
              [matTooltip]="showAddMore ? 'Close Add More' : 'Add More'"
            >
              <i
                [class]="
                  showAddMore
                    ? 'fa fa-close text-danger'
                    : 'fa fa-plus text-primary'
                "
                aria-hidden="true"
              ></i>
            </button>
            }
          </div>
        </div>
      </div>
    </ng-container>
    }
  </div>
  } @if (attachments.value?.length) {
  <div class="row">
    <ng-container [formGroup]="formGroup">
      <ng-container formArrayName="attachments">
        @for (item of attachments.controls; track $index) {
        <ng-container [formGroupName]="$index">
          <div class="col-md-12 pb-2">
            <div
              class="d-flex align-items-center position-relative justify-content-between"
            >
              <a
                class="pointer"
                (click)="
                  downloadFile(
                    item?.value?.receiptPath,
                    item?.value?.receiptName
                  )
                "
              >
                @if (Global.isImage(item?.value?.receiptName)) {
                <img
                  [src]="item?.value?.receiptPath"
                  alt=""
                  class="img-fluid"
                />
                } @else {
                {{ item?.value?.receiptName }}
                }
              </a>
              <div
                [class]="
                  Global.isImage(item?.value?.receiptName)
                    ? 'image-action'
                    : 'p-0 m-0'
                "
              >
                <button
                  mat-icon-button
                  (click)="removeAttachment($index)"
                  [matTooltip]="'Remove File'"
                >
                  <i class="fa fa-trash text-danger" aria-hidden="true"></i>
                </button>
                @if($last && data?.multi){
                <button
                  mat-icon-button
                  (click)="addMore()"
                  [matTooltip]="showAddMore ? 'Close Add More' : 'Add More'"
                >
                  <i
                    [class]="
                      showAddMore
                        ? 'fa fa-close text-danger'
                        : 'fa fa-plus text-primary'
                    "
                    aria-hidden="true"
                  ></i>
                </button>
                }
              </div>
            </div>
          </div>
        </ng-container>
        }</ng-container
      >
    </ng-container>
  </div>
  } @if ((!attachments.value?.length || showAddMore) && !data?.view_only) {
  <div
    class="dropzone"
    fileDragDrop
    (click)="pickFile()"
    (filesChangeEmiter)="onFileChange($event, 'drag')"
  >
    <div class="text-wrapper">
      <div class="centered">
        <label for="file" class="d-flex flex-column pointer"
          ><span class="textLink">Select your file</span>
          <small>or Drop it here!</small></label
        >
      </div>
    </div>
  </div>
  <input
    type="file"
    #fileInput
    accept=".pdf, .xls, .xlsx,.png, .jpeg"
    (change)="onFileChange($event, 'choose')"
    multiple
    class="d-none"
  />
  <div class="d-flex align-items-start">
    <mat-form-field class="w-100 baseweb-no-border-table mb-2">
      <input
        placeholder="Paste image here.."
        (paste)="onPaste($event)"
        matInput
      />
    </mat-form-field>
    <button mat-icon-button (click)="takePicture()">
      <mat-icon>photo_camera</mat-icon>
    </button>
  </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end" *ngIf="!data?.view_only">
  <button
    mat-flat-button
    [disabled]="
      data?.type == 'fareAttachments' &&
      !(formGroup.value.attachments?.length || data?.existing?.length)
    "
    color="primary"
    class="me-2"
    (click)="onSave()"
  >
    Save
  </button>
</mat-dialog-actions>
